import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function useSearchParams<T extends Record<string, string | undefined>>(): T {
	const { search } = useLocation();

	return useMemo(() => {
		const params = new URLSearchParams(search);
		const result: Record<string, string | undefined> = {};

		params.forEach((value, key) => {
			result[key] = value;
		});

		return result as T;
	}, [search]);
}
